import { Card, Modal, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { decryptData } from "../../utils";

export function PlayAudioMpdal({
  callId,
  caseId,
  isVisible,
  recordingUrl,
  handleModalVisibility,
}: {
  caseId: string;
  callId: string;
  isVisible?: boolean;
  recordingUrl: string;
  handleModalVisibility: () => void;
}) {
  const [audioSrc, setAudioSrc] = useState<string>("");
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!isVisible || !recordingUrl) return;

    let objectUrl: string | null = null;
    let cancelled = false;

    const fetchAudio = async () => {
      try {
        const res = await fetch(decryptData(recordingUrl));
        console.log("FETCH STATUS:", res.status);
        console.log("CONTENT-TYPE:", res.headers.get("content-type"));

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);

        if (!cancelled) {
          setAudioSrc(objectUrl);
        }
      } catch (err) {
        console.error("Audio fetch failed:", err);
        setAudioSrc("");
      }
    };

    fetchAudio();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
      setAudioSrc("");
    };
  }, [recordingUrl, isVisible]);

  const handleClose = () => {
    handleModalVisibility();

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  if (!isVisible) return null;

  return (
    <Modal open={true} footer={null} closable={false} destroyOnClose>
      <Card
        title="Play Recording"
        extra={
          <CloseOutlined
            className="text-lg cursor-pointer"
            onClick={handleClose}
          />
        }
      >
        <Row className="flex justify-center">
          {audioSrc ? (
            <audio
              key={audioSrc} // 🔥 force remount
              ref={audioRef}
              controls
              src={audioSrc}
              autoPlay
            />
          ) : (
            <p>Loading audio...</p>
          )}
        </Row>
      </Card>
    </Modal>
  );
}